import React, { useState, useEffect } from "react";
import Tables from "../Components/UserPanelDataTables/tables";

export default function Invoice() {
  const [data, setData] = useState([]);
  useEffect(() => {
    setData({
      head: [
        { key: "invoiceId", label: "Invoice ID" },
        { key: "description", label: "Description" },
        { key: "createdDate", label: "Created Date" },
        { key: "dueDate", label: "Due Date" },
        { key: "amount", label: "Amount" },
        { key: "status", label: "Status" },
        { key: "actions", label: "" },
      ],

      rows: [
        // Row 1
        {
          invoiceId: "#INV0025",
          description: "General Consultation",
          createdDate: "30 Apr 2025",
          dueDate: "30 Apr 2025",
          amount: "$800",
          status: {
            label: "Paid",
            type: "success",
            icon: "ti ti-point-filled",
          },
          actions: [
            { label: "View", type: "dropdown" },
            { label: "Delete", type: "modal", target: "#delete_modal" },
          ],
        },

        // Row 2
        {
          invoiceId: "#INV0026",
          description: "X-Ray & Diagnostics",
          createdDate: "15 May 2025",
          dueDate: "20 May 2025",
          amount: "$650",
          status: {
            label: "Pending",
            type: "warning",
            icon: "ti ti-point-filled",
          },
          actions: [
            { label: "View", type: "dropdown" },
            { label: "Delete", type: "modal", target: "#delete_modal" },
          ],
        },

        // Row 3
        {
          invoiceId: "#INV0027",
          description: "Dental Checkup",
          createdDate: "02 Jun 2025",
          dueDate: "05 Jun 2025",
          amount: "$400",
          status: {
            label: "Overdue",
            type: "danger",
            icon: "ti ti-point-filled",
          },
          actions: [
            { label: "View", type: "dropdown" },
            { label: "Delete", type: "modal", target: "#delete_modal" },
          ],
        },

        // Row 4
        {
          invoiceId: "#INV0028",
          description: "Heart Specialist Visit",
          createdDate: "18 Jun 2025",
          dueDate: "18 Jun 2025",
          amount: "$1200",
          status: {
            label: "Paid",
            type: "success",
            icon: "ti ti-point-filled",
          },
          actions: [
            { label: "View", type: "dropdown" },
            { label: "Delete", type: "modal", target: "#delete_modal" },
          ],
        },
      ],
    });
  }, []);

  return (
    <div className="content content-two">
      <div className="d-flex align-items-sm-center flex-sm-row flex-column gap-2 pb-3 mb-3 border-1 border-bottom">
        <div className="flex-grow-1">
          <h4 className="fw-bold mb-0">
            Invoices
            <span className="badge badge-soft-primary border pt-1 px-2 border-primary fw-medium ms-2 fw-medium fs-13">
              Total Invoices : 582
            </span>
          </h4>
        </div>

        <div className="text-end d-flex">
          <div className="dropdown me-1">
            <a
              href="#!"
              className="btn btn-md fs-14 fw-normal border bg-white rounded text-dark d-inline-flex align-items-center"
              data-bs-toggle="dropdown"
            >
              Export<i className="ti ti-chevron-down ms-2"></i>
            </a>

            <ul className="dropdown-menu p-2">
              <li>
                <a className="dropdown-item" href="#!">
                  Download as PDF
                </a>
              </li>
              <li>
                <a className="dropdown-item" href="#!">
                  Download as Excel
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-3">
        <div className="search-set mb-3">
          <div className="d-flex align-items-center flex-wrap gap-2">
            <div className="table-search d-flex align-items-center mb-0">
              <div className="search-input">
                <a href="#!" className="btn-searchset"></a>
              </div>
            </div>
          </div>
        </div>

        <div className="d-flex table-dropdown mb-3 pb-1 right-content align-items-center flex-wrap row-gap-3">
          <div className="dropdown">
            <a
              href="#!"
              className="dropdown-toggle btn bg-white btn-md d-inline-flex align-items-center fw-normal rounded border text-dark px-2 py-1 fs-14"
              data-bs-toggle="dropdown"
            >
              <span className="me-1"> Sort By : </span> Recent
            </a>
            <ul className="dropdown-menu dropdown-menu-end p-2">
              <li>
                <a href="#!" className="dropdown-item rounded-1">
                  Recent
                </a>
              </li>
              <li>
                <a href="#!" className="dropdown-item rounded-1">
                  Oldest
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-sm-12">
          <div>
            <div className="card-body p-0">
              <Tables data={data} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
